import React from 'react'
import { CMSButton } from '../CMSButton'
import { getCachedGlobal } from '@/utils/getGlobals'
import { ContactVendorButton as ContactVendorButtonType } from '@/payload-types'
import type { TypedLocale } from 'payload'

export interface ContactVendorButtonPropsType {
  key?: React.Key
  appearance?: 'ghost' | 'ghostInverted' | 'primary'
  className?: string
  buttonData?: ContactVendorButtonType
  locale?: TypedLocale
}

export const ContactVendorButton: React.FC<ContactVendorButtonPropsType> = (props) => {
  const { appearance = 'ghost', className, buttonData, locale } = props

  const button = buttonData?.contactVendorButton

  console.log(button)

  return (
    <React.Fragment>
      <CMSButton
        {...button}
        linkType={'popup'}
        appearance={appearance}
        size={appearance === 'primary' ? 'sm' : 'mini'}
        className={className}
        showIconLeft={true}
        iconLeft={button?.iconLeft}
        locale={locale}
      />
    </React.Fragment>
  )
}
